import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitContact = (payload) =>
  apiClient.post("/contact", payload).then((r) => r.data);

export const fetchBlogPosts = (lang = "tr") =>
  apiClient.get(`/blog/posts?lang=${lang}`).then((r) => r.data);

export const fetchBlogPost = (slug, lang = "tr") =>
  apiClient.get(`/blog/posts/${slug}?lang=${lang}`).then((r) => r.data);
